// extracted by mini-css-extract-plugin
export var container = "TitleContainer-module--container--0H5SA";
export var ctaContainer = "TitleContainer-module--ctaContainer--SWDED";
export var ctas = "#226355";
export var grayBackground = "#f6f8fb";
export var row = "TitleContainer-module--row--N1VGo";
export var subtitle = "TitleContainer-module--subtitle--3iSNP";
export var title = "TitleContainer-module--title--6K-BJ";
export var wrapper = "TitleContainer-module--wrapper--GlJ1s";